import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CaseFanGlyph = /*#__PURE__*/createElement("g", {
  id: "case_fan"
}, /*#__PURE__*/createElement("path", {
  d: "M54.8,26.9c-1.5,0.7-2.9,1.7-4.2,2.8c-1.7,1.4-3.3,2.9-4.7,4.6c-0.8,0.9-1.5,1.9-2.2,3c-0.3,0.5-0.7,1.1-0.9,1.7 c-0.3-0.1-0.7-0.1-1.1-0.1c-0.1-0.8-0.4-1.7-0.6-2.5c-0.6-2.5-1.4-4.4-0.9-7.2c1.3-4.9,3.9-13-2-13.6c-5.2-0.4-12.6,7.8-10.6,12.8 c0.6,1.6,1.7,3,2.7,4.4c1.3,1.8,2.7,3.5,4.3,5c0.9,0.8,1.8,1.6,2.8,2.3c0.5,0.3,1.3,0.8,2,1c-0.1,0.3-0.1,0.7-0.1,1 c-0.8,0.1-1.7,0.5-2.5,0.7c-2.3,0.6-4.2,1.5-6.8,1c-4.7-1.5-12.5-4.3-13,2c-0.4,5.4,7.4,13.2,12.2,11.1c1.5-0.7,2.9-1.8,4.2-2.8 c1.7-1.4,3.3-2.9,4.7-4.6c0.8-0.9,1.6-1.9,2.2-3c0.3-0.5,0.7-1.2,1-1.9c0.3,0.1,0.7,0.2,1,0.1c0,0.9,0.4,1.8,0.6,2.7 c0.6,2.5,1.4,4.4,1,7.2c-1.3,4.9-4,13,2,13.6c5.1,0.4,12.5-7.8,10.5-12.8c-0.6-1.6-1.6-3.1-2.6-4.4c-1.3-1.8-2.8-3.5-4.4-5 c-0.9-0.9-1.8-1.6-2.8-2.3c-0.5-0.3-1.2-0.8-1.9-1c0.1-0.4,0.2-0.8,0.2-1.2c0.8-0.1,1.6-0.4,2.4-0.6c2.3-0.7,4.2-1.5,6.8-1 c4.7,1.4,12.4,4.2,12.9-2.1C67.5,32.6,59.6,24.8,54.8,26.9z"
}));
const CaseFan = createSvg({
  name: 'case_fan',
  path: CaseFanGlyph
});

export default CaseFan;
export { CaseFanGlyph };
